import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowRight, Building2, UserRound } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { COMPANY } from "../content/site";
import { useSeo } from "../lib/useSeo";

export default function Contact() {
  useSeo("Kontakt", "Kontakt zu PACTORA Personalpartner, Stiller Winkel 5, 23562 Lübeck. E-Mail: info@pactora-personal.de", "/kontakt");
  return (
    <>
      <PageHero testid="contact-hero" eyebrow="Kontakt" lines={["Wir freuen uns", "auf Ihre Nachricht."]}
        intro="Schreiben Sie uns eine E-Mail oder nutzen Sie direkt eines unserer Formulare – so haben wir alle wichtigen Angaben sofort beisammen." />
      <section className="bg-white pb-24 md:pb-32">
        <div className="container-x grid gap-5 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="h-full rounded-[2rem] bg-[color:var(--navy)] p-8 md:p-12 text-white grain relative overflow-hidden" data-testid="contact-card">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8FD3CE]">Kontaktdaten</p>
              <p className="mt-6 text-2xl font-bold">{COMPANY.brand}</p>
              <a href={COMPANY.mapsUrl} target="_blank" rel="noopener noreferrer" className="mt-8 flex gap-4 group" data-testid="contact-address-link">
                <MapPin className="mt-1 shrink-0 text-[#8FD3CE]" />
                <span className="text-lg leading-relaxed">{COMPANY.street}<br />{COMPANY.city}<br /><span className="text-sm text-[#8FD3CE] underline-offset-4 group-hover:underline">Adresse in der Karte öffnen</span></span>
              </a>
              <a href={`mailto:${COMPANY.email}`} className="mt-8 flex gap-4 group" data-testid="contact-email-link">
                <Mail className="mt-1 shrink-0 text-[#8FD3CE]" />
                <span className="text-lg break-all group-hover:underline underline-offset-4">{COMPANY.email}</span>
              </a>
            </div>
          </Reveal>
          <div className="lg:col-span-7 grid gap-5">
            {[
              { to: "/personal-anfragen", icon: Building2, t: "Sie suchen Personal?", d: "Schildern Sie uns Ihren Bedarf – unverbindlich und mit wenigen Pflichtangaben.", cta: "Personal anfragen", id: "contact-inquiry-card" },
              { to: "/bewerber-registrierung", icon: UserRound, t: "Sie möchten in Deutschland arbeiten?", d: "Registrieren Sie sich kostenlos und laden Sie auf Wunsch Ihren Lebenslauf hoch.", cta: "Als Bewerber registrieren", id: "contact-register-card" },
            ].map((c, i) => (
              <Reveal key={c.to} delay={0.08 * (i + 1)}>
                <Link to={c.to} className="group flex h-full flex-col justify-between gap-8 rounded-[2rem] border border-slate-200 p-8 md:p-10 transition-colors hover:border-[color:var(--teal)] hover:bg-[color:var(--mist)]" data-testid={c.id}>
                  <c.icon className="text-[color:var(--teal-ink)]" size={28} />
                  <div>
                    <h2 className="text-2xl font-bold text-[color:var(--navy)]">{c.t}</h2>
                    <p className="mt-2 text-slate-600">{c.d}</p>
                    <span className="mt-6 inline-flex items-center gap-2 font-semibold text-[color:var(--navy)]">{c.cta} <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
